var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.28 2.816c-0.384-0.864-1.472-1.088-2.144-0.48l-2.24 2.112c-0.512 0.48-1.28 0.48-1.792 0l-2.272-2.080c-0.672-0.64-1.76-0.384-2.112 0.48l-1.856 4.512h14.24l-1.824-4.544zM4.928 12.8h22.080c0.704 0 0.928-0.96 0.32-1.28l-2.72-1.44h-17.248l-2.72 1.44c-0.64 0.32-0.384 1.28 0.288 1.28zM28.768 20.896c-2.816-1.152-5.792-1.76-8.16-2.112-0.576-0.096-1.152 0.256-1.376 0.8l-2.24 5.152c-0.416 0.928-1.664 0.928-2.048 0l-2.176-5.152c-0.256-0.544-0.832-0.896-1.408-0.8-2.368 0.32-5.344 0.96-8.16 2.080-0.576 0.256-0.96 0.864-0.8 1.536l1.152 6.496c0.108 0.622 0.643 1.088 1.287 1.088 0.009 0 0.018-0 0.026-0l-0.001 0h22.24c0.672 0 1.216-0.448 1.312-1.088l1.184-6.496c0.017-0.080 0.027-0.171 0.027-0.265 0-0.564-0.353-1.045-0.85-1.236l-0.009-0.003z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCast);
export default __webpack_public_path__ + "static/media/cast.b245dff807793b867ca52423c7122488.svg";
export { ForwardRef as ReactComponent };